module.exports = __webpack_public_path__ + "static/media/business-time.5d44033e.svg";